import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

export default function ConfirmDialog({
  open,
  handleClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirmar",
  confirmColor = "primary",
  confirmIcon = null,
}) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          startIcon={confirmIcon}
        >
          {confirmText}
        </Button>
        <Button onClick={handleClose} color="inherit" variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
